export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-testid="brand-logo-svg">
    <circle cx="18" cy="18" r="17" stroke="#D4AF37" strokeWidth="1.5" strokeDasharray="3 3" />
    <ellipse cx="18" cy="18" rx="17" ry="7" stroke="#D4AF37" strokeWidth="1.2" opacity="0.7" />
    <circle cx="18" cy="18" r="4" fill="#D4AF37" />
    <polygon points="18,3 20,8 18,6 16,8" fill="#FF9F1C" />
    <polygon points="18,33 20,28 18,30 16,28" fill="#FF9F1C" />
    <polygon points="3,18 8,20 6,18 8,16" fill="#FF9F1C" />
    <polygon points="33,18 28,20 30,18 28,16" fill="#FF9F1C" />
  </svg>
);

export const LogoLockup = () => (
  <span className="flex items-center gap-3">
    <LogoMark className="h-9 w-9" />
    <span className="flex flex-col items-start leading-none">
      <span className="font-serif text-lg font-medium tracking-[0.22em] text-[#F8FAFC]">AETHERIA</span>
      <span className="mt-1 font-mono text-[8px] font-medium tracking-[0.5em] text-[#D4AF37]">CHRONO-ATLAS</span>
    </span>
  </span>
);
